<template>
  <transition
    name="fade"
    mode="out-in"
    enter-active-class="transition-opacity duration-500 ease-in-out"
    leave-active-class="transition-opacity duration-500 ease-in-out"
    enter-from-class="opacity-0"
    enter-to-class="opacity-100"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div
      v-if="show"
      class="absolute inset-0 z-10 flex flex-col items-center justify-center bg-primary bg-cover bg-center transition-opacity duration-500"
    >
      <div class="relative bottom-6 flex animate-pulse flex-col items-center gap-2">
        <img :src="logo" alt="Logo" class="w-1/2 max-w-[400px]" />
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
import logo from '@/assets/ssn-logo.png'
import { onMounted, ref } from 'vue'

const show = ref(true)

onMounted(async () => {
  await new Promise((resolve) => {
    setTimeout(() => {
      resolve(true)
    }, 500)
  })

  show.value = false
})
</script>
